import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IAdvizeService {

  private readonly platformId = inject(PLATFORM_ID);

  trackTransaction(id: string, amount: number): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const iAdvizeWindow = window as any;
    iAdvizeWindow.iAdvizeInterface = iAdvizeWindow.iAdvizeInterface || [];
    iAdvizeWindow.iAdvizeInterface.push(function(iAdvize: any) {
      iAdvize.recordTransaction({
        amount: amount,
        id: id
      });
    });
  }
}
